import React from 'react';
import { POPUP_TYPE, STATUS, TEXT, FORM_FIELD } from '../../../constants';
import { vendorLogout } from '../../../service';
import { popup } from '../../../utils';
import { clearProfileSession, getDocumentRuntime, loginUrl } from '../../../backend/runtime';


export const Logout = () => {
  const handleLogout = async () => {
    const runtime = getDocumentRuntime();
    try {
      const response = await vendorLogout();
      if (!response) return;
      if (response.status === STATUS.FAIL) {
        popup(POPUP_TYPE.ERR, response.message || TEXT.NO_LOGOUT);
      } else {
        clearProfileSession(runtime.profile, window.localStorage, runtime.session);
        window.location.assign(loginUrl(runtime));
      }
    } catch (error) {
      popup(POPUP_TYPE.ERR, error.message);
    }
  };

  return (
    <div className="collapse navbar-collapse bg-white" id="ProfileSideBar">
      <p className="user-links mb-0" onClick={handleLogout}>
        {FORM_FIELD.LOG_OUT}
      </p>
    </div>
  );
};
